import * as d3 from 'd3';

const parseTime = d3.timeParse("%d-%b-%Y");

export const getProjectedDeficitChartData = fundingForecast => {
  const deficitByAsset = d3.nest()
    .key(x => x.AssetXSReturn)
    .entries(fundingForecast);

  return deficitByAsset.map(x => ({ asset: x.key, values: x.values.map(d => ({ date: parseTime(d.Date), deficit: d.Deficit })) }));
}

export const getContributionsChartData = (fundingForecast, date) => {
  return fundingForecast.filter(x => x.Date === date)
    .map(x => ({ id: x.AssetXSReturn, value: x.RCR, }));
}

export const getWaterfallChartData = (fundingWaterfall, date, asset) => {
  const data = fundingWaterfall.find(x => x.Date === date && x.AssetXSReturn === asset);

  return [
    { id: 'Existing Assets', value: data['Existing Assets'] },
    { id: 'Contributions', value: data.Contributions },
    { id: 'Assets XS1', value: data.AssetsXS1 },
    { id: 'Assets XS2', value: data.AssetsXS2 },
    { id: 'Deficit', value: data.Deficit },
    { id: 'Liability Premium', value: data.LiabilityPremium },
    { id: 'Liabilities', value: -data.Liabilities },
  ];
}

export const getkeyFiguresTableData = (fundingForecast, date, asset) => {
  const forecast = fundingForecast.find(x => x.Date === date && x.AssetXSReturn === asset);

  return {
    '': [
      { id: 'Target date', value: d3.timeFormat('%d %B %Y')(d3.timeParse('%d-%b-%Y')(date)) },
      { id: 'Asset XS return', value: asset },
      { id: 'Projected deficit', value: d3.format(',.0f')(forecast.Deficit) },
      { id: 'Contributions to remove deficit (pa)', value: d3.format(',.0f')(forecast.RCR) },
    ],
  }
}

export const getInitialDate = fundingForecast => {
  const dates = fundingForecast.map(x => x.Date).sort();

  return dates[Math.floor(dates.length / 2)];
}

export const getInitialAsset = fundingForecast => {
  return fundingForecast[0].AssetXSReturn;
}


// WEBPACK FOOTER //
// ./src/dashboards/FundingForecast/selectors.js